/* @flow */

import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { StoreInfoContext } from "entrypoint/shared";
import ChevronIcon from "icons/chevron-mini.svg";

import styles from "./styles.scss";

const Back = (): React$Node => {
  const { content: { transactionsview }, routes: { accountView } } = useContext(StoreInfoContext);

  if (!accountView || !accountView.url) {
    return null;
  }

  return (
    <Link className={styles.back} to={accountView.url}>
      <ChevronIcon />
      <span>{transactionsview.goBackText}</span>
    </Link>
  );
};

export default Back;
